/**
 * Testweergave — the shared (client-safe) constants for an operator's
 * preview of an E.-facing or stable surface (see testweergave.server.ts
 * and stal-access.server.ts `startPreview`). A preview rides the ordinary
 * `oyka_stal` cookie with a `mintedVia: 'preview'` token row; the surface
 * shows the banner and refuses every write. A refused write bounces back
 * to the page with `?testweergave=alleen-kijken`, which the banner reads.
 */
export const PREVIEW_VIA = 'preview'
export const PREVIEW_READONLY_PARAM = 'testweergave'
export const PREVIEW_READONLY_VALUE = 'alleen-kijken'
/** where the banner's "Terug naar Oyka" posts and where a stop lands */
export const TESTWEERGAVE_PATH = '/app/instellingen/testweergave'
